import { useCallback } from 'react';

import { Badge } from '../../../components/ui';
import { useT } from '../../../i18n';
import { HANH_DONG } from '../constants';
import { laPhuongThucHttp } from '../nghiep-vu/danh-muc-hanh-dong';
import type { QuyetDinh } from '../types';

/**
 * Kết quả của một thao tác — **cố ý thưa** (§8.2 mục 9): "Cho phép" chỉ là chữ
 * mờ, chỉ "Từ chối" mới thành nhãn đỏ. Tô xanh mọi dòng thành công thì cột này
 * thành một dải màu và dòng bị từ chối chìm mất.
 */
export function NhanKetQua({ quyetDinh }: { quyetDinh: QuyetDinh }) {
  const { t } = useT();
  return quyetDinh === 'DENY' ? (
    <Badge variant="danger">{t('nhatKy.ketQua.DENY')}</Badge>
  ) : (
    <span className="text-xs text-content-muted">{t('nhatKy.ketQua.ALLOW')}</span>
  );
}

/**
 * Tên thao tác. Phương thức HTTP (Gateway, SDK lấy mẫu request) thành "Gọi API
 * (GET)", đường dẫn hiện ở dòng dưới như cũ; mã lạ hiện kèm câu "chưa có trong
 * danh mục".
 */
export function useTenHanhDong(): (ma: string) => string {
  const { t } = useT();
  return useCallback(
    (ma: string) => {
      if (laPhuongThucHttp(ma)) return t('nhatKy.goiApi', { phuongThuc: ma });
      const khoa = HANH_DONG[ma];
      return khoa ? t(khoa) : t('nhatKy.hanhDongLa', { ma });
    },
    [t],
  );
}
